import React from "react"
import { Auth0Provider } from "@auth0/auth0-react"
import { navigate, GatsbyBrowser } from "gatsby"

import { Layout } from "./src/components/layout"
import "gatsby-plugin-breadcrumb/gatsby-plugin-breadcrumb.css"

const onRedirectCallback = () => {
  navigate("/", { replace: true })
}

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
  props,
}) => {
  return <Layout {...props}>{element}</Layout>
}

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => {
  return (
    <Auth0Provider
      domain={process.env.GATSBY_AUTH0_DOMAIN}
      clientId={process.env.GATSBY_AUTH0_CLIENTID}
      authorizationParams={{ redirect_uri: window.location.origin }}
      onRedirectCallback={onRedirectCallback}
    >
      {element}
    </Auth0Provider>
  )
}
